import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { SharedService } from 'src/app/shared/shared.service';
import { AppConstants } from 'src/app/config.service';
import { finalize } from 'rxjs/operators';
import * as moment from 'moment'
import { ExceptionHandlingService } from 'src/app/shared/exception-handling.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastService, IMyOptions } from 'ng-uikit-pro-standard';


@Component({
  selector: 'mark-recieved-modal',
  templateUrl: './mark-recieved-modal.component.html',
  styles: [`
      .compTbl th,
      .compTbl td {
        padding:4px;
        vertical-align:middle
      }
    `]
})
export class MarkRecievedModalComponent implements OnInit {

  @Input() certificate: any;
  @Output() emitSuccess = new EventEmitter<any>();
  error: any = {}

  constructor(
    private service: SharedService,
    private appConstants: AppConstants,
    private errorService: ExceptionHandlingService,
    private toastr: ToastService,
    private translate: TranslateService
  ) { }

  ngOnInit() {}

  datePickerOptions: IMyOptions = {
    dateFormat: 'mmm-dd-yyyy',
    closeAfterSelect: true,
    editableDateField: false
  };

  @ViewChild('markComponentsReceivedModal', { static: true }) markComponentsReceivedModal: any;
  selectedComponent: any = {};
  action: any = {}

  ngOnChanges() {
    if (this.certificate && this.certificate.id) {
      this.action = {};
      let d = new Date()
      this.action.dateReceived = moment(d).format('MMM-DD-YYYY');
      this.getQueryComponents()
      this.markComponentsReceivedModal.show();
    }
  }

  loader: boolean = false
  components: Array<any> = [];
  getQueryComponents() {
    this.components = [];
    this.loader = true;
    this.service.post(this.appConstants.endPoints.certificatesEndPoint + 'critical-components/query-components', {}, {
      "ids": this.certificate.components,
      "isPaging": false
    })
      .pipe(finalize(() => {
        this.loader = false;
      }))
      .subscribe(data => {
        const components = data && data.searchResults ? data.searchResults : [];
        this.components = components.map(res => {
          if (res.quantityText * 1 != res.totalComponentsReceived) {
            res['isSelected'] = true;
            res['componentsReceived'] = (res.quantityText * 1);
          }
          return res
        })
      }, res => {
        this.errorService.errorHandling(res).then(res => {
          this.error = res;
        });
      });
  }



  confirmMarkComponentsReceived() {
    let criticalComponentIds = []
    let url = this.appConstants.endPoints.certificatesEndPoint + 'critical-components/mark-received';
    this.components.map((comp) => {
      if (comp.isSelected)
      criticalComponentIds.push({
          "criticalComponentId": { id: comp.id },
          "componentsReceived": comp.componentsReceived
        })
    })
    let modelSchema = {
      "dateReceived": moment(this.action.dateReceived).utc().format('YYYY-MM-DDTHH:mm:ss') + 'Z',
      "comments": this.action.comments ? this.action.comments : '',
    }
      modelSchema["criticalComponentIds"] = criticalComponentIds

    this.loader = true;
    this.service.put(url, {}, modelSchema).pipe(finalize(() => {
      this.loader = false;
    }))
      .subscribe(data => {
        this.markComponentsReceivedModal.hide();
        this.emitSuccess.emit(true);
        this.toastr.success(this.translate.instant('administration_componentsMarkedReceivedSuccessfully_label'), this.translate.instant('administration_confirmation_label'));
      },
        error => {
          this.errorService.errorHandling(error).then(res => {
            this.error = res;
          });
        })
  }

  updateComponentsReceived(ev, comp) {
    setTimeout(() => {
      if (ev.target.control.checked) {
        comp.componentsReceived = (comp.quantityText * 1)
      } else {
        comp.componentsReceived = 0;
      }
    }, 200)
  }
  updateCheckedState(comp) {
    if (comp.componentsReceived > (comp.quantityText * 1)) {
      comp.componentsReceived = (comp.quantityText * 1)
    }
    if (comp.componentsReceived < (comp.quantityText * 1)) {
      comp.isSelected = false
    }
    else {
      comp.isSelected = true
    }
  }
  checkedState() {
    let val = false;
    val = this.components.some(res=> res.isSelected == true)
    return val;

  }
}